module.exports = __webpack_public_path__ + "static/media/culqi-logo.eb51b9ec.webp";